import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

// import { getTextColor } from '../../../../constants/ui';
// import { getReadableTripStatus } from '../../../../constants/app';
// import { getImageByService } from '../../../../themes/images';
// import NavigationConstants from '../../../../constants/navigations';

const ItemTourPackage = React.memo(({ item }) => {
    const navigate = useNavigate();
    
    const { amount, cab_request } = item?.bid || {};
    const { pickup_location, requestedCruze } = cab_request || {};
    const cruzeType = requestedCruze ? requestedCruze : 'CAR';
    // const cruze = getImageByService(cruzeType);

    let tripStatus = item?.paymentDetails?.state !== 'COMPLETED' || item?.paymentDetails?.responseCode !== 'SUCCESS'
        ? 'CANCELLED'
        : item.status;

    const navigateToNext = () => {
        if (!cab_request) return;
        navigate(`/trip-details/${item.id}`);
    };

    return (
        <div onClick={navigateToNext} className={`${cab_request ? 'cursor-pointer' : 'cursor-default'} p-4 m-2 rounded-lg border border-gray-300 bg-white`}>
            <div className="flex justify-between items-center pb-2 border-b border-dashed border-gray-300">
                <span className="text-sm text-gray-700">
                    {moment(item?.tripDate).format('DD MMM, YYYY')} • {moment(item.tripTime).format('hh:mm A')}
                </span>
                <span className={`text-sm font-semibold`}>
                    {/* {getReadableTripStatus(tripStatus)} */}
                </span>
            </div>

            <div className="flex justify-between items-center mt-3">
            {/* <img src={cruze} alt="Cruze Type" className="w-12 h-12 object-contain" /> */}
                {/* <img src={cruze} alt="Cruze Type" className="w-12 h-12 object-contain" /> */}
                <div className="flex-1 ml-3">
                    <p className="text-sm font-semibold text-gray-900">{item?.tripTitle}</p>
                    <hr className="my-1 border-gray-300" />
                    <p className="text-xs text-gray-600">
                        {cab_request ? `From: ${pickup_location?.title || 'Pickup unavailable'}` : 'Trip details unavailable'}
                    </p>
                </div>
                {item.status !== 'CANCELLED' && (
                    <div className="flex flex-col items-center">
                        <div className="flex items-center text-gray-900">
                            <span className="text-sm">&#8377;</span>
                            <span className="text-lg font-bold">{amount}</span>
                        </div>
                        {item?.paymentDetails?.state === 'COMPLETED' && (item?.paymentDetails?.responseCode === 'SUCCESS'|| item?.paymentDetails?.responseCode === 'PAYMENT_SUCCESS') ? (
                            <span className="px-2 py-1 text-xs text-green-800 bg-green-200 rounded">Paid</span>
                        ) : (
                            <span className="px-2 py-1 text-xs text-red-800 bg-red-200 rounded">Unpaid</span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
});

export default ItemTourPackage;
